export default {
  common: {
    email: "Email",
    contactAdministrator: "Oops! Something went wrong. Please contact the administrator.",
    search: "Search",
    approve: "Approve",
    approved: "Approved",
    pending: "Pending",
    viewProfile: "Open",
    editInfo: "Edit info",
    saveChanges: "Save changes",
    add: "Add",
    cancel: "Cancel",
    apply: "Apply",
    clear: "Clear",
    back: "Back",
    confirmation: "Confirmation",
    upload: "Upload",
    readMore: "Read more",
    readLess: "Read less",
    showArchived: "Show archived",
    quantromContactDetails: "Need further assistance? Contact us:",
  },
  authentication: {
    logInTo: "Log In to",
    password: "Password",
    logIn: "Log In",
    forgetPassword: "Forgot your password?",
    backToLogIn: "Back to log in",
    credentialsWrong: "These credentials do not match our records",
    twoFactor: {
      setupTwoStepVerification: "Set-up 2-factor authentication",
      step2: "Step 2/2",
      scanImage: "Scan the image below with the Google Authentication app on your  phone. ",
      enterSixDigits: "Enter the six-digit code from application",
      afterScanning: "After scanning the image, the app will display a six-digit code that you can enter below:",
      scanningProblems: "If you have problems with the scanning, please insert the following code in Google Authentication app:",
      twoStepVerification: "2-Step Verification",
    },
    resetPassword: {
      resetPassword: "Reset password",
      enterEmail: "Enter the email address associated with your account and we’ll send you a link to reset your password.",
      sendLink: "Send link",
    },
    resetPasswordConfirmation: {
      verifyEmail: "Verify your email address",
      sendEmail: "You’re almost done! We’ve sent you an email with instructions on how to reset your password.",
    },
    changePassword: {
      changePassword: "Change password",
      newPassword: "New password",
      passwordConfirmation: "Password confirmation",
    },
    changePasswordConfirmation: {
      passwordChanged: "Password changed!",
      passwordChangedSuccessfully: "Your password has been changed successfully. Use your new password to log in.",
      goToLogin: "Go to login",
    },
    finaliseAccount: {
      finaliseAccountSetup: "Finalise account setup",
      stepOneFromTwo: "Step 1/2",
      nextStep: "Next step",
      errorMail: "Mail is not matching token!",
    },
    newPassword: {
      passwordComplexity: {
        weak: "Password complexity: Weak",
        medium: "Password complexity: Medium",
        strong: "Password complexity: Strong",
      },
      passwordContain: "Password must contain:",
      sixChar: "at least 6 characters",
      eigthChar: "at least 8 characters",
      oneUpprCase: "at least 1 upper case character",
      ourRecommandation: "Our recommandation:",
      oneNumber: "At least one number",
      oneSpecialChar: "At least one special character (e.g. {'@'}!#%$)",
    },
  },
  investors: {
    menu: {
      dashboard: "Dashboard",
      portfolio: "Portfolio",
      reports: "Reports",
      myAccount: "My account",
      inbox: "Inbox",
      logOut: "Log out",
    },
    avatar: {
      viewAccount: "View account",
    },
    dashboard: {
      investmentStats: {
        totalHoldings: "Total holdings",
        portfolioYtdPerformance: "Portfolio YTD performance",
        assetSummary: "Asset summary",
        assetQuantity: "Asset quantity",
        assetPrice: "Last asset price",
        return: "Total return",
        currentHoldings: "Current Holdings",
        totalSubscriptionNotes: "Total QP2PL Notes Subscribed",
        totalRedemptionNotes: "Total QP2PL Notes Redeemed",
        totalNotes: "Current QP2PL Notes",
        asset: "Asset",
        lastPrice: "Last price",
      },
      investmentsDataTable: {
        history: "History",
        lastNumberMonths: "last {months} months",
        checkWallet1: "Check your",
        checkWallet2: "Portfolio",
        checkWallet3: "for the full overview",
        date: "Date",
        dealingDate: "Dealing date",
        assetType: "Asset type",
        quantity: "Quantity",
        assetPrice: "Asset price",
        value: "Value",
        actionType: "Action type",
        status: "Status",
        noDataFound: "No data found",
        dataLoading: "Data loading. Please wait",
      },
      lastSubscription: {
        lastSubscription: "Last subscription",
        date: "Date",
        status: "Status",
        newSubscription: "New subscription",
        redemption: "Redemption",
      },
      latestNews: {
        latestNews: "Lastest news",
        readArticle: "Read article",
      },
      portfolio: {
        portfolio: "Portfolio",
        quantromLending: "Quantrom P2P Lending PPN ",
        year: "Year",
        lastTwelveMonths: "Last 12 months",
        all: "All",
        allStats: "Lifetime performance",
        monthRange: "From {minMonth} till {maxMonth}",
        currentPortfolio: "Current portfolio",
      },
      reports: {
        reports: "Reports",
        belowDocumentsReturnsGenerated: "In the below documents you can read about all of the details regarding how your returns are generated.",
        btnPersonalReports: "Personal reports",
        btnMonthlyReports: "Monthly reports",
        btnYearlyReports: "Yearly reports",
        btnNewsletters: "Newsletters",
        showAllReports: "Show All",
        quantromPeerToPeerReports: "Quantrom peer to peer lending reports",
      },
      account: {
        myAccount: "My account",
        personalInformation: "Personal information",
        title: "Title",
        firstName: "First name",
        lastName: "Last name",
        ssn: "Social Security Number",
        email: "Email",
        mobile: "Mobile",
        phone: "Phone",
        otherNationality: "Other nationality",
        investorSince: "Investor since",
        addressInfo: "Address information",
        address: "Address",
        zip: "ZIP",
        city: "City",
        country: "Country",
        countryOfResidence: "Country of residence",
        bankingInfo: "Banking information",
        bank: "Bank",
        ibanNumber: "IBAN Number",
        bicCode: "Bic Code",
        kycDocument: "KYC Document",
        kycDocuments: "KYC Documents",
        newDocuments: "New Documents",
        kycDocumentApproved: "Approved KYC documents",
        kycDocumentUploaded: "Uploaded KYC documents",
        dealDocuments: "Deal documents",
        privateDocuments: "Private documents",
        companyInformation: "Company Information",
        companyName: "Company name",
        companyNumber: "Company number",
        primaryContactPerson: "Primary contact person",
        primarySignatory: "Primary signatory",
        signatory: "Signatory",
        name: "Name",
        incomeSourceAndWealth: "Source of income and wealth",
        reasonForSubscription: "Reason for subscription",
        quantromAwarness: "How you became aware of Quantrom",
        sourceOfWealth: "Source of wealth",
        industryAndOccupation: "Industry and occupation",
        purposeOfInvestment: "Business activity",
        reasonSubscription: "Reason for subscription",
        sourceOfIncomeText: "Source of wealth",
      },
      notifications: {
        inbox: "Inbox",
        btnNewMessages: "Unread messages",
        btnOldessages: "Read messages",
        btnMarkedAsRead: "Marked as read",
        markAllRead: "Mark all as read",
        markAllUnread: "Mark all as unread",
        markAsRead: "Mark as read",
        markAsUnread: "Mark as unread",
      },
    },
  },
  advisor: {
    menu: {
      dashboard: "Dashboard",
      investors: "Investors",
      signOut: "Sign out",
    },
    dashboard: {
      title: "Advisor Dashboard",
      welcome: "Welcome",
      intro: "View your assigned investors, upload documents on their behalf, and onboard new investors.",
      goToInvestors: "Go to investors",
    },
    investors: {
      title: "Investors",
      createInvestorButton: "Create new investor",
      resumeOrReset: {
        header: "Pick up where you left off?",
        intro: "You have a Create Investor form in progress.",
        question: "What would you like to do?",
        continueDescription: "Keep your progress and resume where you left off.",
        startFreshDescription: "Discard the saved data and start a new form.",
        continue: "Continue",
        startFresh: "Start fresh",
      },
    },
    profile: {
      title: "Investor profile",
      newSubscription: "New subscription",
    },
    createInvestor: {
      title: "Create new investor",
      steps: {
        type: "Investor type",
        details: "Details",
        documents: "Documents",
        review: "Review",
      },
      nav: {
        next: "Next",
        submit: "Submit",
      },
      step1: {
        title: "What kind of investor are you onboarding?",
        subtitle: "Select whether the new account is for an individual or a company.",
        individual: "Individual",
        individualHelp: "A natural person investing in their own name.",
        company: "Company",
        companyHelp: "A legal entity investing on behalf of a business.",
      },
      step2: {
        individualTitle: "Investor details",
        companyTitle: "Company details",
      },
      step3: {
        title: "Upload supporting documents",
        subtitle: "Provide identification and proof of address so we can run KYC.",
        optionalNote: "Documents can also be uploaded later from the investor's profile.",
        requiredNote: "All documents are required to complete onboarding.",
        totalSize: "Total upload size: {used} of {max}",
      },
      step4: {
        title: "Review and submit",
        subtitle: "Check that everything is correct before sending the contract for signing.",
      },
      individual: {
        personalDetails: "Please enter your personal details",
        title: "Title",
        firstName: "First name",
        lastName: "Last name",
        socialSecurityNumber: "Social security number",
        contactDetails: "Contact details",
        email: "Email",
        mobileNumber: "Mobile",
        phoneNumber: "Phone",
        countryOfResidence: "Country of residence",
        addressSection: "Address",
        zip: "ZIP",
        sourceOfIncomeSection: "Source of income / occupation",
        sourceOfIncome: "Source of income / occupation",
        industryExplanation: "Industry / explanation",
        industryExplanationPlaceholder: "Explain what industry you currently work in or have worked in",
        politicalSection: "Politically exposed person",
        pep: "Are you a Politically Exposed Person (PEP) self-declaration",
        anotherNationality: "Do you have more than 1 nationality?",
        anotherNationalityValue: "Nationality",
        anotherNationalityValuePlaceholder: "Nationality:",
        purposeSection: "Why do you subscribe to Quantrom P2P Lending (purpose of your investment)",
        purposeOfInvestment: "Purpose of investment",
        purposeOfInvestmentPlaceholder: "Enter purpose of investment here",
        awarenessSection: "How did you become aware of Quantrom P2P Lending?",
        quantromAwareness: "Source of awareness",
        quantromAwarenessPlaceholder: "Enter source of information",
        sourceOfWealthSection: "Source of Wealth",
        sourceOfWealth: "Source of wealth",
        sourceOfWealthPlaceholder: "e.g.: personal savings, inheritance, sale of assets",
      },
      address: {
        address: "Address",
        zipcode: "Postal code",
        city: "City",
        country: "Country",
      },
      banking: {
        section: "Please enter your banking information",
        help: "During the subscription process you will have to present a proof that you own the bank account from which you will transfer your investment to Quantrom",
        bankName: "Bank",
        iban: "IBAN Number",
        bic: "Bic code",
      },
      investment: {
        section: "Enter the amount you want to subscribe",
        amount: "Amount you want to subscribe",
        amountHelp: "The amount in EUR the investor wants to subscribe.",
        minimumError: "The amount must be at least 10.000 €",
      },
      kyc: {
        section: "Please select one of the below KYC methods:",
        method: "KYC method",
        help: "How identity verification will be carried out for this investor.",
      },
      terms: {
        section: "Terms and conditions",
        confirm: "I confirm that I have read the above terms and agree with them",
      },
      documents: {
        passportOrId: "Passport or ID",
        passportOrIdHelp: "Copy of valid passport and/or national identity card (one file) verifying the social security number in the country of tax residence.",
        utilityBill: "Proof of address",
        utilityBillHelp: "Letter from authorities, bank, utility bill, or similar document stating your name and address.",
        proofOfAddress: "Proof of address",
        proofOfAddressHelp: "Letter from authorities, bank, utility bill, or similar document stating your name and address.",
        bankAccountProof: "Bank account ownership proof",
        bankAccountProofHelp: "Proof that you own the bank account from which the investment will be transferred to Quantrom.",
        structureChart: "Structure chart",
        structureChartHelp: "Updated structure chart including Ultimate Beneficial Owners, signed no longer than 3 months ago.",
        articlesOfAssociation: "Articles of Association",
        articlesOfAssociationHelp: "Articles of Association or equivalent constitutional document.",
        businessRegisterExtract: "Business register extract",
        businessRegisterExtractHelp: "Business register extract or equivalent document.",
        beneficialOwnershipRegister: "Beneficial ownership register",
        beneficialOwnershipRegisterHelp: "Extract from the register of beneficial ownership.",
        boardDecision: "Board decision",
        boardDecisionHelp: "Board decision to invest in Quantrom P2P Lending DAC.",
        authorisedSignatoriesList: "Authorised signatories list",
        authorisedSignatoriesListHelp: "List of authorised signatories, if available or applicable.",
      },
      company: {
        companyInformation: "Please enter the information about the company that wants to subscribe",
        companyName: "Company name",
        companyNumber: "Company number",
        addressSection: "Registered address",
        businessActivities: "Your business activities and the industry that your organisation works in",
        businessActivitiesPlaceholder: "What industry are you primarily active in and what is the purpose of your company, e.g. holding structure, operating/investment company, etc.",
        sourceOfWealth: "Source of Wealth",
        sourceOfWealthPlaceholder: "e.g.: retained earnings, share capital, sales of the company, etc.",
        purposeOfInvestment: "Why do you subscribe to Quantrom P2P Lending (purpose of your investment)",
        purposeOfInvestmentPlaceholder: "Enter purpose of investment here",
        primaryContact: "Please enter name of the primary contact person",
        primaryContactHelp: "The main point of contact for the account — typically someone the advisor speaks to day-to-day.",
        primarySignatory: "Please enter a primary signatory person for the company",
        primarySignatoryHelp: "The person with legal authority to sign on behalf of the company. May or may not be the same person as the primary contact.",
        primaryFirstName: "Primary contact first name",
        primaryLastName: "Primary contact last name",
        primaryEmail: "Primary contact Email",
        primaryMobile: "Primary contact mobile number",
        primaryPhone: "Primary contact phone number",
        additionalSignatoriesSection: "Additional signatories",
        additionalSignatoriesHelp: "Add any other people authorised to sign on behalf of the company.",
        addAnotherSignatory: "Add another signatory",
        signatoryN: "Signatory {n}",
        signatoryFirstName: "Primary signatory first name",
        signatoryLastName: "Primary signatory last name",
        signatoryEmail: "Primary signatory Email",
        signatoryMobile: "Primary signatory mobile number",
        signatoryPhone: "Primary signatory phone number",
        errors: {
          companyNameRequired: "Company name is required",
          companyNumberRequired: "Company Number is required",
          addressRequired: "Address is required",
          postalCodeRequired: "Postal code is required",
          cityRequired: "City is required",
          countryRequired: "Country is required",
          contactFirstRequired: "Contact person first name is required",
          contactLastRequired: "Contact person last name is required",
          emailRequired: "Email is required",
          mobileRequired: "Mobile is required",
          signatoryFirstRequired: "Signatory person first name is required",
          signatoryLastRequired: "Signatory person last name is required",
          bankRequired: "Bank is required",
          ibanRequired: "IBAN Number is required",
          bicRequired: "Bic code is required",
          amountRequired: "Amount you want to subscribe is required",
          sourceOfIncomeDetailRequired: "Detailed information about source of income is required",
        },
      },
      review: {
        yes: "Yes",
        no: "No",
        notProvided: "Not provided",
        termsAccepted: "Terms accepted",
      },
      errors: {
        required: "This field is required",
        answerRequired: "Answer is required",
        anotherNationalityRequired: 'The other Nationality is required if "yes" is selected',
        sourceOfIncomeRequired: "Source of income is required",
        industryExplanationRequired: "Industry and ocuppation is required",
        sourceOfWealthRequired: "Source of wealth is required",
        kycMethodRequired: "KYC method is required",
        invalidEmail: "Please enter a valid email address",
        termsRequired: "You must accept the terms to continue",
        formInvalidSummary: "Some fields are invalid",
        formInvalidDetail: "Please review the highlighted fields and try again.",
        accountExistsSummary: "Account already exists",
        accountExistsDetail: "An account with this email is already registered. Use a different email or open the existing profile.",
        submitFailedSummary: "Submission failed",
        submitFailedDetail: "We couldn't create the investor. Please try again — if it keeps happening, contact support.",
        fileTooLarge: "This file is {size}. The maximum is {max} per document — please upload a smaller or compressed version.",
        totalTooLarge:
          "The documents add up to {used}, which is over the {max} limit for a single submission. Replace the largest files with compressed versions. Note that using the same file in two slots uploads it twice.",
        payloadTooLargeSummary: "Documents are too large",
        payloadTooLargeDetail: "The upload exceeded the server's size limit, so nothing was saved. Go back to the documents step and replace the largest files with compressed versions.",
      },
      success: {
        summary: "Investor created",
        detail: "The contract has been sent for signing. The investor account will be activated once everything is signed.",
      },
    },
  },
  admin: {
    approveTransfer: "Approve transfer",
    menu: {
      dashboard: "Dashboard",
      investors: "Investors",
      controlPanel: "Control panel",
      advisorCompanies: "Advisor companies",
      advisorUsers: "Advisor users",
    },
    dashboard: {
      tabs: {
        newInvestors: "New Investors",
        subscriptions: "Subscriptions",
        redemption: "Redemptions",
      },
      newInvestors: {
        dataTable: {
          name: "Name",
          entity: "Individual/company",
          createdAt: "Initial Investment Date",
          amount: "Initial Investment Amount",
          kyc: "KYC",
          contract: "Contract",
          subscription: "Subscription",
          actions: "Actions",
        },
      },
      newSubscriptions: {
        subscriptionPending: "Subscription pending",
        noteAttribution: "Note attribution",
        openSubscriptionModal: "Open subscription",
        totalSubscriptions: "Total subscriptions",
        totalTransfers: "Total transfers received",
        totalTransfersReceiving: "Total transfers receiving",
        dataTable: {
          name: "Name",
          entity: "Individual/company",
          createdAt: "Subscription date",
          dealingDate: "Dealing date",
          amount: "Amount",
          action: "Action",
        },
      },
      newRedemptions: {
        redemptionPending: "Redemptions pending",
        redemptionCompleted: "Redemptions completed",
        approveTransfer: "Approve Transfer",
        openRedemptionModal: "Open Redemption",
        totalRedemptions: "Total redemptions",
        dataTable: {
          name: "Name",
          entity: "Individual/company",
          createdAt: "Redemption date",
          dealingDate: "Dealing date",
          amount: "Amount",
        },
      },
    },
    investors: {
      tabs: {
        individuals: "Individuals",
        companies: "Companies",
      },
      customers: {
        dataTable: {
          name: "Name",
          externalId: "External ID",
          email: "Email",
          latestActivity: "Latest activity",
          latestActivityType: "Latest activity type",
          currentPortfolio: "Current portfolio value",
        },
      },
      companies: {
        dataTable: {
          name: "Name",
          phone: "Phone",
          email: "Email",
          currentPortfolio: "Current portfolio value",
        },
      },
    },
    profile: {
      profile: "Profile",
      reset2Fa: "Reset 2FA",
      deleteInvestor: "Archive investor",
      kyc: "KYC",
      contract: "Contract",
      subscriptions: "Subscriptions",
      redemptions: "Redemptions",
      userAccount: "User account",
      createuser: "Create user",
      notifications: "Notifications",
      viewLogs: "View logs",
      advisorCompany: "Advisor company",
      noAdvisorCompany: "No advisor company",
      noAdvisorCompanyFound: "No advisor company found",
      advisorCompanyUpdated: "Advisor company updated",
    },
    advisorCompanies: {
      advisorCompanies: "Advisor companies",
      addAdvisorCompany: "Add advisor company",
      dataTable: {
        name: "Company name",
        companyNumber: "Company number",
        address: "Address",
        postalCode: "Postal code",
        city: "City",
        country: "Country",
        createdAt: "Created at",
      },
      form: {
        name: "Company name",
        companyNumber: "Company number",
        address: "Address",
        postalCode: "Postal code",
        city: "City",
        country: "Country",
      },
    },
    advisorUsers: {
      advisorUsers: "Advisor users",
      advisorUsersForCompany: "Advisor users — {company}",
      addAdvisorUser: "Add advisor user",
      dataTable: {
        username: "Username",
        advisorCompany: "Advisor company",
        createdAt: "Created at",
      },
    },
    controlPanel: {
      tabs: {
        assetType: "QP2PL PPN",
        reports: "Reports",
        globalNotifications: "Global notifications",
        adminUsers: "Admin users",
      },
      assetType: {
        price: "Price",
        action: "Action",
        newNotePrice: "New note price",
        notePriceHistory: "Note price history",
        processSubscriptionsAndRedemptions: "Process subscriptions and redemptions",
        dataTable: {
          date: "Date",
          price: "Price",
          updateBy: "Update by",
          action: "Action",
          editPrice: "Edit price",
        },
      },
      reports: {
        monthlyReport: "Monthly report",
        yearlyReport: "Yearly report",
        newsletters: "Newsletters",
        otherReports: "Other reports",
        personalReports: "Personal reports",
        generatePersonalReports: "Generate reports",
        btnUnpublished: "Unpublished reports",
        btnPublished: "Published reports",
        dataTable: {
          date: "Date",
          name: "Name",
          updateBy: "Update by",
          actions: "Actions",
        },
        reportOnNoteHolders: "Report on note holders",
        publishSelected: "Publish selected",
        deleteSelected: "Delete selected",
        selected: "Selected",
        of: "of",
        toastPublishedReports: "{count} report(s) have been published",
        toastDeletedReports: "{count} report(s) have been deleted",
      },
      notifications: {
        newNotification: "New notification",
      },
      adminUser: {
        adminUser: "Admin user",
        addAdminUser: "Add admin user",
        dataTable: {
          username: "Username",
        },
      },
    },
  },
  modals: {
    updateNotePrice: {
      updateNotePrice: "Update note price for",
      processSubscriptionsAndRedemptions: "Process subscriptions and redemptions for {date}",
      processTransactions: "Process transactions",
      currentPrice: "Current QP2PL PPN price: {currentNotePrice}€",
      newPrice: "New QP2PL PPN price",
      confirmDialogMsg: "Are you sure you want to proceed with updating the note price?",
      dataTable: {
        notes: "notes",
        notePrice: "Note price",
        subscriptionFee: "Subscription Fee",
        type: "Subscription/Redemption",
      },
    },
    uploadReport: {
      report: "report",
      uploadTypeReport: "Upload {type}",
      reportName: "{type} name",
      uploadReport: "Upload report",
    },
    sendNotification: {
      sendGlobalNotification: "Send global notification",
      subject: "Subject",
      message: "Message",
      sendNotification: "Send notification",
    },
    uploadKycDocument: {
      uploadKycDocument: "Upload KYC document",
      kycDocument: "Document name",
      kycDocumentUpload: "Upload document",
      document: "Document",
    },
    uploadPrivateDocument: {
      uploadPrivateDocument: "Upload private document",
      documentName: "Document name",
      document: "Document",
      privateDocumentUpload: "Upload document",
    },
    newSubscription: {
      newSubscription: "New subscription",
      enterAmount: "Enter the amount you want to subscribe",
      enterAmountForInvestor: "Enter the amount to subscribe on behalf of the investor",
      amount: "Amount",
      amountLowerCase: "amount",
      submitSubscription: "Submit subscription",
      kycMethod: "KYC method",
      confirmDialogHeader: "Confirm subscription",
      confirmDialogMsg: "Submit a new subscription with {amount}?",
    },
    newRedemption: {
      newRedemption: "New redemption",
      enterAmount: "Enter the amount you want to redeem",
      amount: "Amount",
      amountLowerCase: "amount",
      submitRedemption: "Submit redemption",
      minimumAmountWithFee: "Minimum redemption is EUR 5,000. Redemption fee is EUR 50.",
      currentAmount: "Total holdings",
      minimumHolding: "Minimum holding*",
      confirmNoteRedeem: "I hereby confirm, that if the value of my remaining number of Profit Participation Notes becomes less than EUR 5,000, my remaining number of Notes will also be redeemed.",
      confirmDialogHeader: "Confirm redemption",
      confirmDialogMsg: "Submit a new redemption with {amount}?",
    },
    generatePersonalReports: {
      generatePersonalReports: "Generate personal reports",
      selectRange: "Select periode",
      submitGenerateReport: "Generate reports",
      confirmDialogMsg: "Are you sure you want to proceed with creating the personal reports for {selected} of {total} selected investors in the period from {from} till {to}?",
      dataTable: {
        name: "Name",
        entity: "Individual/company",
      },
    },
    audits: {
      dataTable: {
        title: "Investor logs",
        createdAt: "Created",
        entity: "Activity",
        event: "Event",
        oldValues: "Old values",
        newValues: "New values",
        user: "User",
      },
    },
    dealingDate: {
      setDealingDate: "Set dealing date",
      confirmDialogHeader: "Confirm dealing date",
      confirmDialogMsg: "Set dealing date on {date}?",
      dealingDateAt: "set on",
      transferredAt: "Transfer received on",
      dealingDate: "Dealing date",
      redemptionProcessedOn: "Redemption processed on",
    },
    approveSubscriptionTransfer: {
      approveTransfer: "Approve transfer",
      confirmDialogHeader: "Approve transfer",
      confirmDialogMsg: "Approve transfer of {amount}?",
    },
    reportOnNoteHolders: {
      reportOnNoteHolders: "Report on note holders",
      previousBalanceSheet: "Previsous BalanceSheet Date",
      subscriptions: "Subscriptions (notes)",
      redemptions: "Redemptions (notes)",
      balanceSheet: "BalanceSheet Date",
      totals: "Totals",
    },
    adminUsers: {
      addAdminUser: "Add admin user",
      editAdminUser: "Edit admin user",
      username: "Username",
      accountExists: "Username is already in use",
    },
    advisorCompanies: {
      addAdvisorCompany: "Add advisor company",
      editAdvisorCompany: "Edit advisor company",
    },
    advisorUsers: {
      addAdvisorUser: "Add advisor user",
      editAdvisorUser: "Edit advisor user",
      advisorCompany: "Advisor company",
      selectAdvisorCompany: "Select advisor company",
      accountExists: "Username is already in use",
    },
  },
  dialogs: {
    approveKycDialog: "Do you want to approve KYC?",
    approveContractDialog: "Do you want to approve contract?",
    approveSubscriptionDialog: "Do you want to approve subscription?",
    createUserDialog: "Do you want to create the user and send activation mail?",
    resetPasswordDialog: "Do you want to send password reset mail to user?",
    resetTwoFactorDialog: "Do you want to reset Two Factor Authentication for user?",
    approveTransferDialog: "Do you want to approve this transfer?",
    cancelSubscriptionDialog: "Do you want to cancel this subscription?",
    cancelRedemptionDialog: "Do you want to cancel this redemption?",
    approveRedemptionDialog: "Do you want to approve this redemption?",
    deleteInvestor: "Do you want to archive this investor?",
    changeAdvisorCompany: "Do you want to change the advisor company from {from} to {to}?",
    unarchiveInvestor: "Do you want to unarchive this investor?",
    approveDocument: "Do you want to approve this document",
    deleteDocument: "Do you want to delete this document",
    subscription: "Subscription",
    contractNotSigned: "Contract has not yet been signed.",
    redemption: "Redemption",
    deleteAdminUser: "Are you sure you want to delete {username}?",
    deleteAdvisorCompany: "Are you sure you want to delete {name}?",
    deleteAdvisorUser: "Are you sure you want to delete {username}?",

    deleteRecord: "Do you want to delete this record?",
    deleteSelectedRecords: "Do you want to delete selected record(s)?",
  },
};
